import SBEditable from "../../components/sbEditable/sbEditable";
import { useState } from "react";
import styles from "./accordionItem.module.scss";
import { UpArrowSVG, DownArrowSVG } from "../../svg/arrowsSVG";
import RichTextWithBlokRenderer from "../../components/richTextRenderer/richTextRenderer";

/// Blok:accordionItem
// accordionitem:blok
///
/// headline:string
/// content:richtext
function AccordionItem({ blok }) {
  const [open, setOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);

  //Doing it this way prevents the hiding animation from running on page load.
  let contentClassNames = `${styles.content}`;
  if (open) {
    contentClassNames += ` ${styles.activeContent}`;
  } else if (!open && hasOpened) {
    contentClassNames += ` ${styles.hideContent}`;
  }

  return (
    <SBEditable blok={blok}>
      <div className={`${styles.root}` + (open ? ` ${styles.activeRoot}` : "")}>
        <div className={styles.headline}>
          <p className={styles.headlineText}>{blok.headline}</p>
          <div
            className={styles.circle}
            onClick={() => {
              setOpen(!open);
              setHasOpened(true);
            }}
          >
            <div className={`${styles.arrow}` + 
            (!open ? ` ${styles.inactiveArrow}` : ` ${styles.activeArrow}`)}>
              {open ? <UpArrowSVG /> : <DownArrowSVG />}
            </div>
          </div>
        </div>
        <div
          className={
            `${styles.divider}` +
            (!open ? ` ${styles.inactiveDivider}` : ` ${styles.middleDivider}`)
          }
        />
        <div className={contentClassNames}>
          <div className={styles.contentPaddingWrapper}>
            <RichTextWithBlokRenderer document={blok.content} />
          </div>
        </div>
        <div className={styles.divider} />
      </div>
    </SBEditable>
  );
}

export default AccordionItem;
